import config from '@/dataroom/app/config/config';
import { LogoDealVDRStandart } from '@dealroadshow/uikit-logo/DealVDR/Standart';
import { LogoLoanSendStandart } from '@dealroadshow/uikit-logo/LoanSend/Standart';
import { Logo17g5Standart } from '@dealroadshow/uikit-logo/17g5/Standart';
import { LogoInvestorSetStandart } from '@dealroadshow/uikit-logo/InvestorSet/Standart';
import { LogoVerisendStandart } from '@dealroadshow/uikit-logo/Verisend/Standart';
import { LogoResearchRoomStandart } from '@dealroadshow/uikit-logo/ResearchRoom/Standart';

export const dataRoomLogoMapping = {
  [config.tenant.tenantDealvdr.code]: LogoDealVDRStandart,
  [config.tenant.tenantLoansend.code]: LogoLoanSendStandart,
  [config.tenant.tenant17g5.code]: Logo17g5Standart,
  [config.tenant.tenantInvestorSet.code]: LogoInvestorSetStandart,
  [config.tenant.tenantVeriSend.code]: LogoVerisendStandart,
  [config.tenant.tenantResearchRoom.code]: LogoResearchRoomStandart,
};
